import Component from './Icon.vue';

export default {
  install(Vue) {
    Vue.component('BkfIcon', Component);
  },
};
